import { apiUrl, fetchJson } from '../../apiBase';

export async function getTeacherHomeSummary(school, { classId } = {}) {
  const params = new URLSearchParams();
  if (classId) params.set('class_id', classId);
  const query = params.toString();
  const url = apiUrl(`/admin/teacher-home/${encodeURIComponent(school)}${query ? `?${query}` : ''}`);
  const res = await fetchJson(url);
  if (!res.ok) throw new Error(await res.text());
  return res.json();
}